import { Injectable } from "@angular/core"
import gql from "graphql-tag"
import { QueryRef, Apollo } from "apollo-angular"
import { ApolloQueryResult } from "apollo-client"
import { Observable } from "rxjs"

interface CustomerPostsQueryVariables {
  customerId: number
  writerId: number
  states: string[]
}

interface AccountPostsQueryVariables {
  writerId: number
  states: string[]
}

export interface Post {
  id: number
  title: string
  customer: {
    id: number
    businessName: string
  }
}

export interface CustomerPostsData {
  customer: {
    id: number
    posts: {
      totalCount: number
      entries: Post[]
    }
  }
}

export interface AccountPostsData {
  account: {
    id: number
    posts: {
      totalCount: number
      entries: Post[]
    }
  }
}

@Injectable({providedIn: 'root'})
export class ConfirmBlockModalQueries {
  constructor(private apollo: Apollo) {

  }

  customerPostsQuery(variables: CustomerPostsQueryVariables): Observable<ApolloQueryResult<CustomerPostsData>> {
    return this.apollo.query<CustomerPostsData>({
      query: gql`
        query ConfirmBlockModalCustomerQuery(
          $customerId: ID!,
          $writerId: Int,
          $states: [String]
        ) {
          customer(id: $customerId) {
            id
            posts(state: $states, writerId: $writerId) {
              totalCount
              entries {
                id
                title
              }
            }
          }
        }
      `,
      variables,
      fetchPolicy: 'network-only'
    })
  }

  accountPostsQuery(variables: AccountPostsQueryVariables): Observable<ApolloQueryResult<AccountPostsData>> {
    return this.apollo.query<AccountPostsData>({
      query: gql`
        query ConfirmBlockModalAccountQuery(
          $writerId: Int,
          $states: [String]
        ) {
          account {
            id
            posts(state: $states, writerId: $writerId) {
              totalCount
              entries {
                id
                title
                customer {
                  id
                  businessName
                }
              }
            }
          }
        }
      `,
      variables,
      fetchPolicy: 'network-only'
    })
  }
}
